<template>
  <div class="card border-0 bg-white profile-settings-card rounded-0">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <form v-on:submit="submit">
        <div class="row">
          <!-- NAME -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.organization.label') }}*
              </label>
              <input v-model="center.name" class="form-control shadow-none text-black" required
                :class="[{ 'is-invalid': submitted && errors?.name }]" />
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.name ?? false">
                <p v-for="error in errors.name" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
          <div class="col-12"></div>
          <!-- DEPARTMENT -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.department.label') }}*
              </label>
              <input v-model="center.department" class="form-control shadow-none text-black" required
                :class="[{ 'is-invalid': submitted && errors?.department }]" />
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.department ?? false">
                <p v-for="error in errors.department" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
          <!-- MAIN_CONTRACTOR -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.main_contractor.label') }}
              </label>
              <input v-model="center.main_contractor" class="form-control shadow-none text-black"
                :class="[{ 'is-invalid': submitted && errors?.main_contractor }]" />
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.main_contractor ?? false">
                <p v-for="error in errors.main_contractor" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
          <!-- CONTANCT -->
          <div class="col-12">
            <h4 class="mb-15 mb-sm-20 mb-md-25">{{ $t('form.section.department_information') }}</h4>
          </div>
          <!-- EMAIL -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.email.label') }}*
              </label>
              <input v-model="center.email" class="form-control shadow-none text-black"
                pattern="[^@\s]+@[^@\s]+\.[^@\s]+" required :placeholder="$t('form.email.placeholder')"
                :class="[{ 'is-invalid': submitted && errors?.email }]" />
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.email ?? false">
                <p v-for="error in errors.email" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
          <!-- PHONE_NUMBER -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.phone.label') }}
              </label>
              <input v-model="center.phone" class="form-control shadow-none text-black"
                :class="[{ 'is-invalid': submitted && errors?.phone }]" />
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.emphoneail ?? false">
                <p v-for="error in errors.phone" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
          <!-- WEBSITE -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.website.label') }}
              </label>
              <input v-model="center.website" class="form-control shadow-none text-black"
                :class="[{ 'is-invalid': submitted && errors?.phwebsiteone }]" />
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.website ?? false">
                <p v-for="error in errors.website" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
          <!-- LOCATION -->
          <div class="col-12">
            <h4 class="mb-15 mb-sm-20 mb-md-25">{{ $t('form.section.location') }}</h4>
          </div>
          <!-- ADDRESS -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.address.label') }}*
              </label>
              <input v-model="center.address" class="form-control shadow-none text-black" required
                :class="[{ 'is-invalid': submitted && errors?.address }]" />
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.address ?? false">
                <p v-for="error in errors.address" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
          <!-- ZIP_CODE -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.zip_code.label') }}*
              </label>
              <input v-model="center.zip_code" class="form-control shadow-none text-black" required
                :class="[{ 'is-invalid': submitted && errors?.zip_code }]" />
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.zip_code ?? false">
                <p v-for="error in errors.zip_code" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
          <!-- COUNTRY -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.country.label') }}*
              </label>
              <country-select v-model="center.country" :country="center.country"
                class="form-select shadow-none text-black fs-md-15" required
                :class="[{ 'is-invalid': submitted && errors?.country }]" />
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.country ?? false">
                <p v-for="error in errors.country" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
          <!-- LANG -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25" v-if="locales.length > 1">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('feature.contents.lang') }}
              </label>
              <div class="d-flex gap-3 align-items-center">
                <select class="form-select shadow-none text-black pe-50 fs-14 fw-medium w-auto"
                  v-model="center.def_language_code" @change="changeLang()" required :disabled="disableLangSelect">
                  <option v-for="locale in locales" :value="locale" :key="locale">{{
                    $t(`feature.contents.$lang.${locale}`) }}</option>
                </select>
              </div>
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.lang ?? false">
                <p v-for="error in errors.lang" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
          <!-- ZONE -->
          <div class="col-md-6" v-if="zones && zones.length > 0">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('feature.roles.zone') }}
              </label>
              <div class="d-flex gap-3 align-items-center">
                <select class="form-select shadow-none text-black pe-50 fs-14 fw-medium" v-model="center.zone_id"
                  :class="[{ 'is-invalid': submitted && errors?.zone_id }]"
                  @change="changeLang(zones.find((z) => z.id === center.zone_id)?.language_code)">
                  <option :value="null" :key="-1">{{ }}
                  </option>
                  <option v-for="zone in zones" :value="zone.id" :key="zone.id!">{{ zone.name }}
                  </option>
                </select>
              </div>
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.zone_id ?? false">
                <p v-for="error in errors.zone_id" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
          <!-- REGISTRATION ENABLED -->
          <div class="col-12">
            <div class="form-check form-group form-switch mb-25 mt-15">
              <input class="form-check-input shadow-none me-8" type="checkbox" role="switch" v-model="center.is_registration_enabled"
                id="is_registration_enabled">
              <label class="form-check-label fw-medium position-relative top-1" for="is_registration_enabled">
                {{ $t('form.is_registration_enabled.label') }}
              </label>
            </div>
          </div>

          <div class="col-12" v-if="loading">
            <SpinnerLoading />
          </div>
          <div class="col-md-12" v-else>
            <div class="d-flex align-items-center justify-content-between gap-3">
              <!-- DELETE -->
              <button v-if="update" type="button" class="bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                data-bs-toggle="modal" data-bs-target="#confirmModal">
                <i class="ph ph-trash lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative">{{ $t('cta.delete_center') }}</span>
              </button>
              <span v-else></span>
              <!-- SAVE -->
              <div class="d-flex flex-wrap gap-3 justify-content-end ms-auto">
                <DiscardButton
                  @confirm="$router.push({ path: update ? `/center/${(center as CenterInfo).id!}` : '/system-centers' })" />
                <button
                  class="default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
                  type="submit" v-on:click="submitted = true">
                  {{ $t('cta.save_center') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- ERROR MESSAGE -->
  <div class="row justify-content-center">
    <div class="col">
      <div
        class="alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25"
        role="alert" id="errorMessage">
        <strong>{{ $t('error.something_went_wrong') }}</strong>
        <button type="button" class="btn-close" v-on:click="hideError" aria-label="Close"></button>
      </div>
    </div>
  </div>
  <ConfirmModal @confirm="deleteCenter()" :title="$t('cta.$delete.title')" :message="$t('cta.$delete.message')" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ConfirmModal from "@/components/Widgets/ConfirmModal.vue";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import { RoleInfo } from "@/utils/models/user.model";
import { CenterBaseInfo, CenterInfo } from "@/utils/models/center.model";
import { removeNullProperties } from "@/utils/methods/remove_null_properties";
import API from "@/services/api/api.service";
import DiscardButton from "@/components/Widgets/DiscardButton.vue";
import config from "@/utils/const/config";
import { Zone } from "@/utils/models/zone.model";
import { disableCursor } from "@fullcalendar/core/internal";

export default defineComponent({
  name: "CenterForm",
  components: {
    ConfirmModal,
    SpinnerLoading,
    DiscardButton,
  },
  data: function () {
    const _center = this.$route.meta.center as CenterBaseInfo | undefined | null;
    return {
      center: (_center !== undefined ? {
        ..._center,
        def_language_code: _center?.def_language_code ?? process.env.VUE_APP_LANG as string
      } : {
        def_language_code: process.env.VUE_APP_LANG as string
      }) as CenterBaseInfo,
      submitted: false,
      roles: undefined as RoleInfo[] | undefined,
      loading: false,
      errors: undefined as any,
      zones: this.$route.meta.zones as Zone[] | undefined,
      disableLangSelect: false as boolean,
    }
  },
  computed: {
    update(): boolean {
      return this.$route.meta.center !== undefined && this.$route.meta.center !== null;
    },
    locales(): string[] {
      return config.available_locales;
    },
  },
  methods: {
    submit(event): void {
      this.errors = undefined;
      event.preventDefault();
      console.log("CENTER", this.center);
      removeNullProperties<CenterInfo>(this.center);

      this.loading = true;
      if (this.update) {
        console.log('UPDATE');
        API.updateCenter((this.center as CenterInfo)).then((response) => {
          this.$router.push(`/center/${response.data.data.id}`);
        }).catch((error) => {
          this.errors = error.response?.data?.errors;
          this.showError();
        }).finally(() => {
          this.loading = false;
        });
      } else {
        console.log('CREATE');

        API.createCenter(this.center).then((response) => {
          this.$router.push(`/center/${response.data.data.id}`);
        }).catch((error) => {
          this.errors = error.response?.data?.errors;
          this.showError();
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    deleteCenter(): void {
      this.loading = true;
      API.deleteCenter((this.center as CenterInfo).id!).then((response) => {
        if (response.data.success === true) {
          this.$router.push('/system-centers');
        }
      }).catch((error) => {
        this.showError();
      }).finally(() => {
        console.log("DELETED_CENTER_ID", (this.center as CenterInfo).id);
        this.loading = false;
      })
    },
    showError() {
      const error = document.getElementById('errorMessage');
      error?.classList.add('show');
      setTimeout(() => {
        this.hideError();
      }, 5000)
    },
    hideError() {
      const error = document.getElementById('errorMessage');
      error?.classList.remove('show');
    },
    changeLang(lang?: string) {
      this.disableLangSelect = false;

      console.log(this.locales, "locales")

      if (lang !== undefined) {
        this.disableLangSelect = true;
        this.center.def_language_code = lang
      }
    }
  },
});
</script>